import { IconBoltFilled, IconSparkles } from "@tabler/icons-react"
import doordash from "../../assets/images/Doordash.webp"
import ubereats from "../../assets/images/UberEats.webp"
import grubhub from "../../assets/images/Grubhub.webp"
import { EzCaterLogoLg } from "../../view/FinanceReco"
import doordashdrive from "../../assets/images/partner/DoordashLogo.webp"
import Bilal_img from "../../assets/images/partner/Bilal_image.webp"
import { Link } from "react-router-dom"
import { motion } from 'framer-motion'
import { item } from "../homepage/Section1"

const Section1 = () => {
  return (
    <>
    <div className="s1-partner m-auto">
        <div className="bg-grid text-center">
            <div className="c1"></div>
            <div className="c2"></div>
            <div className="row">
                <div className="col-2 logo-left">
                    <Link target="_blank" to={'https://merchants.doordash.com/en-us/products/drive-on-demand?_ga=2.127768900.871705318.1755073741-950003465.1754579713&_gl=1*1hhbafz*_gcl_au*ODYxNzkxODUuMTc1NDU3OTcxMw'}><img src={doordashdrive} style={{backgroundColor: "#FB2B07"}} className="olo-logo rounded-pill p-1 shadow animate__animated animate__backInLeft" alt="Doordash drive brand logo" /></Link><br/>
                    <Link target="_blank" to={'https://auth.uber.com/v2/?breeze_init_req_id=77b25032-b243-401a-b251-d2b15fa5e5e8&breeze_local_zone=dca18&next_url=https%3A%2F%2Fmerchants.ubereats.com%2Fmanager%2F&sm_flow_id=0L4czj5O&state=MWk_Vm3Djj8KNoKK58e74p62QYHGv-t9KXdJtcNomlw%3D'}><img src={ubereats} className="r365-logo rounded-pill shadow animate__animated animate__backInLeft" alt="UberEats brand logo" /></Link>
                </div>
                <motion.div whileInView="visible" initial="hidden" className="col-lg-8 col-sm-12">
                    <motion.div variants={item} whileInView="visible" initial="hidden" className="top-text">
                        <p><IconSparkles className="color-brand animate__animated animate__bounceIn animate__infinite animate__slower" /> #1 AI Restaurant Operations Automation Platform</p>
                    </motion.div>
                    <motion.div variants={item} whileInView="visible" initial="hidden" className="s1-head-text">
                        <h1 className="pt-2"><span>Voosh</span> x <span>Olo</span>: Turn Order Issues Into Revenue and Happy Customers</h1>
                        <p>Voosh helps Olo's restaurant partners automatically recover lost delivery revenue and unlock new operations automation without any heavy lifting. Our tools plug into the systems you already use — Olo, third-party delivery apps, POS, accounting, CCTV — start seeing the recovered dollars within the first billing cycle.</p>
                    </motion.div>
                    <motion.div variants={item} whileInView="visible" initial="hidden" className="d-flex gap-3 justify-content-center s1-btn-grp">
                        <a href="#becomeAPartner"><div className="btn btn-dark rounded-pill shadow p-3 fw-bold bcm_partner_btn"><IconBoltFilled  className="color-brand" /> <ShinyText text="Send a Referral" disabled={false} speed={3} className='custom-class' /></div></a>
                        <Link to={'https://meetings.hubspot.com/bilal-k-s/meeting-with-bilal'}><div className="btn btn-outline-secondary rounded-pill shadow py-2 pe-3 fw-bold bilal_profile"><img className="rounded-pill" src={Bilal_img} alt="Bilal profile" /> Talk to a Voosh Expert</div></Link>
                    </motion.div>
                </motion.div>
                <div className="col-2 logo-right">
                    <Link target="_blank" to={'https://www.ezcater.com/caterer_portal/sign_in?dest_url=http%3A%2F%2Fezmanage.ezcater.com%2Forders'}><img src={EzCaterLogoLg} className="lunchbox-logo rounded-pill shadow animate__animated animate__backInDown" alt="ezcater brand logo" /></Link>
                    <Link target="_blank" to={'https://restaurant.grubhub.com/login/'}><img src={grubhub} className="crumbs-logo rounded-pill shadow animate__animated animate__backInRight" alt="grubhub brand logo" /> <br/></Link>
                    <Link target="_blank" to={'https://identity.doordash.com/auth?client_id=1643580605860775164&redirect_uri=https%3A%2F%2Fmerchant-portal.doordash.com%2Fauth_callback&scope=*&prompt=none&response_type=code&layout=merchant_web_v2&state=62f73e82-c257-4c2c-9b91-1c43b7f8ddfa&allowRedirect=true&failureRedirect=%2Fmerchant%2Flogin'}><img src={doordash} className="chatmeter-logo rounded-pill shadow animate__animated animate__backInDown" alt="DoorDash brand logo" /></Link>
                    <div className="blur-color-1 rounded-pill"></div>
                    <div className="blur-color-2 rounded-pill"></div>
                </div>
            </div>
            
        </div>
    </div>
    </>
  )
}

const ShinyText = ({ text, disabled = false, speed = 5, className = '' }) => {
  const animationDuration = `${speed}s`;

  return (
    <div
      className={`shiny-text ${disabled ? 'disabled' : ''} ${className}`}
      style={{ animationDuration }}
    >
      {text}
    </div>
  );
};

export default Section1